{
  "fr": {
    "building": {
      "attributes": {
        "description": "Description",
        "elevators": "Nombre d'ascenceurs",
        "end_date": "Date d'achèvement",
        "floors": "Nombre d'étages",
        "internal_note": "Note interne",
        "name": "Nom",
        "start_date": "Date de début",
        "surface_shared": "Espace commun"
      },
      "labels": {
        "building": "Pas de bâtiment | Un bâtiment | {count} Bâtiments"
      },
      "toasts": {
        "create": "Bâtiment créé",
        "delete": "Bâtiment supprimé",
        "update": "Bâtiment modifié"
      },
      "validation": {
        "needName": "Champ requis",
        "needNumber": "Doit être un nombre (par exemple 85.5)"
      }
    }
  }
}
